var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    selectedDaysFromStep32: null,
};
var selectedDaysSlice = createSlice({
    name: "selectedDays",
    initialState: initialState,
    reducers: {
        setSelectedDays: function (state, action) {
            state.selectedDaysFromStep32 = action.payload;
        },
        resetSelectedDays: function (state) {
            state.selectedDaysFromStep32 = null;
        },
    },
});
export var setSelectedDays = (_a = selectedDaysSlice.actions, _a.setSelectedDays), resetSelectedDays = _a.resetSelectedDays;
export default selectedDaysSlice.reducer;
